import { render, staticRenderFns } from "./interest-point-item.vue?vue&type=template&id=5306902f&scoped=true&"
import script from "./interest-point-item.vue?vue&type=script&lang=js&"
export * from "./interest-point-item.vue?vue&type=script&lang=js&"
import style0 from "./interest-point-item.vue?vue&type=style&index=0&id=5306902f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5306902f",
  null
  
)

export default component.exports